import { render } from "./select2-group.vue?vue&type=template&id=7d52daa8"
import script from "./select2-group.vue?vue&type=script&lang=js"
export * from "./select2-group.vue?vue&type=script&lang=js"

import "./select2-group.vue?vue&type=style&index=0&id=7d52daa8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__